<script setup lang="ts">
import Card from '@/components/Card.vue';
</script>

<template>
    <v-fade-transition appear>
        <v-row class="d-flex justify-md-start justify-center">
            <Card
                name="Alle medewerkers"
                imageUrl="/images/employees.svg"
                :route="{ name: 'superadmin-employees' }"
                text="Hier staat een overzicht van alle medewerkers"
            />
            <Card
                name="Alle bedrijven"
                imageUrl="/images/company.svg"
                :route="{ name: 'superadmin-organizations' }"
                text="Hier staat een overzicht van alle bedrijven"
            />
            <Card name="Alle teams" imageUrl="/images/teams.svg" route="/hoofdbeheer/teams" text="Hier staat een overzicht van alle teams" />
            <Card
                name="Notificaties"
                imageUrl="/images/notifications.svg"
                :route="{ name: 'admin-notifications-create' }"
                text="Hier kunnen notificaties gemaakt en verstuurd worden"
            />
            <Card
                name="Globale bronnen"
                imageUrl="/images/sources.svg"
                :route="{ name: 'superadmin-sources' }"
                text="Hier staat een overzicht van alle globale bronnen"
            />
        </v-row>
    </v-fade-transition>
</template>
